/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { GridView, Griew, Column, Response, Filter } from "react-griew";
import Pasoonate from "pasoonate";
import BankAccountService from "../../service/bank-account-service";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import CreateCompanyBankAccountWindow from "./CreateCompanyBankAccountWindow";
import EditCompanyBankAccountWindow from "./EditCompanyBankAccountWindow";
import BalanceBankAccountWindow from "./BalanceBankAccountWindow";
import AuthorizationService from "../../service/authorization-service";
import ImportBillBankAccountWindow from "./ImportBillBankAccountWindow";

const authorizationService = new AuthorizationService();
const bankAccountService = new BankAccountService();
const griew = new Griew();

await loadDictionary("bank-account-company-section");

function CompanyBankAccountMainPage() {
  const [count, setCount] = useState(0);
  const [selectedBankAccountId, setSelectedBankAccountId] = useState(null);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [isOpenBalanceWindow, setIsOpenBalanceWindow] = useState(false);
  const [isOpenImportBillWindow, setIsOpenImportBillWindow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const reloadList = () => { 
    setIsLoading(true);

    griew.filters.add('party_id', Column.NUMBER, Filter.IS_EQUAL_TO, null, null);
    griew.options.add('accessible_accounts', true)
    griew.refresh();
  };
  const remove = (id) => {
    bankAccountService.findOne(id).then(bankAccount => {
      if(bankAccount && confirm(i18n.t("bank_account.main_page.remove_alert"))) {
        bankAccountService.remove(bankAccount).then(result => {
          if(result) {
            reloadList();
          }
        }).catch(error => {
          console.error(error);
        });
      }
    });    
  };
  const handleOpenCreateWindow = (bankAccountId) => {
    setSelectedBankAccountId(bankAccountId);
    setIsOpenCreateWindow(true);
  };
  const handleCloseCreateWindow = () => {
    setSelectedBankAccountId(null);
    setIsOpenCreateWindow(false);
  };
  const handleOpenEditWindow = (bankAccountId) => {
    setSelectedBankAccountId(bankAccountId);
    setIsOpenEditWindow(true);
  };
  const handleCloseEditWindow = () => {
    setSelectedBankAccountId(null);
    setIsOpenEditWindow(false);
  };
  const handleOpenBalanceWindow = (bankAccountId) => {
    setSelectedBankAccountId(bankAccountId);
    setIsOpenBalanceWindow(true);
  };
  const handleCloseBalanceWindow = () => {
    setSelectedBankAccountId(null);
    setIsOpenBalanceWindow(false);
  };
  const handleRemoveBankAccount = (bankAccountId) => {
    remove(bankAccountId);
  };
  const handleOpenImportBillWindow = (bankAccountId) => {
    setSelectedBankAccountId(bankAccountId);
    setIsOpenImportBillWindow(true);
  };
  const handleCloseImportBillWindow = () => {
    setSelectedBankAccountId(null);
    setIsOpenImportBillWindow(false);
  };

  useEffect(() => {
    prepareGriew(setCount, handleOpenEditWindow, handleOpenBalanceWindow, handleRemoveBankAccount, handleOpenImportBillWindow, setIsLoading);
    reloadList();
  }, []);

  return (
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("bank-account-company-section.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-primary me-2 mb-2 " + (authorizationService.cannot('bank_account_create') ? 'd-none' : '')} type="button" onClick={handleOpenCreateWindow}>{i18n.t("bank-account-company-section.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
        <CreateCompanyBankAccountWindow key={`create-${Date.now()}`} isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
        <EditCompanyBankAccountWindow key={`edit-${selectedBankAccountId}`} isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} bankAccountId={selectedBankAccountId} />
        <BalanceBankAccountWindow key={`balance-${selectedBankAccountId}`} isOpenWindow={isOpenBalanceWindow} onCloseWindow={handleCloseBalanceWindow} bankAccountId={selectedBankAccountId} />
        <ImportBillBankAccountWindow key={`import-bill-${selectedBankAccountId}`} isOpenWindow={isOpenImportBillWindow} onCloseWindow={handleCloseImportBillWindow} bankAccountId={selectedBankAccountId} />
      </div>
  );
}

function prepareGriew(setCount, handleOpenEditWindow, handleOpenBalanceWindow, handleRemoveBankAccount, handleOpenImportBillWindow, setIsLoading) {
  const list = [
    {
      name: "id",
      caption: "کد",
      schema: "BankAccount",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "party_id",
      caption: "شناسه طرف حساب",
      schema: "BankAccount",
      type: Column.NUMBER,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: false
    },
    {
      name: "party_name",
      caption: "طرف حساب",
      schema: "Party",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: false,
      beforeRender: (value, bankAccount) => {
        return bankAccount?.party?.name;
      }
    },
    {
      name: "name",
      caption: "نام حساب",
      schema: "BankAccount",
      type: Column.STRING,
      order: 3,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "bank_name",
      caption: "نام بانک",
      schema: "Bank",
      type: Column.STRING,
      order: 4,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, bankAccount) => {
        return bankAccount?.bank?.name;
      }
    },
    {
      name: "account_number",
      caption: "شماره حساب",
      schema: "BankAccount",
      type: Column.STRING,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "iban",
      caption: "شماره شبا",
      schema: "BankAccount",
      type: Column.STRING,
      order: 6,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "card_number",
      caption: "شماره کارت",
      schema: "BankAccount",
      type: Column.STRING,
      order: 7,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "created_at",
      caption: "تاریخ ایجاد",
      schema: "BankAccount",
      type: Column.DATETIME,
      order: 8,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "updated_at",
      caption: "تاریخ ویرایش",
      schema: "Party",
      type: Column.DATETIME,
      order: 9,
      sortable: false,
      filterable: false,
      visibility: false,
      beforeRender: (value) => { 
        const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{updatedAt}</span>;
      },
    },
    {
      name: "",
      caption: "عملیات",
      schema: "",
      type: Column.STRING,
      order: 10,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, bankAccount) => { 
        const transactionPageLink = bankAccount.has_financial_channel && authorizationService.can('bank_account_transactions') ? <a className="btn btn-sm btn-light" href={`/bank-accounts${bankAccount.type === "bon_card" ? "/bon-cards" : ""}/${bankAccount.id}/transactions`}>{i18n.t("bank-account-company-section.transaction_page_link")}</a> : '';
        const balanceButton = bankAccount.has_financial_channel && authorizationService.can('bank_account_balance') ? <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenBalanceWindow(bankAccount.id) }}>{i18n.t("bank-account-company-section.balance_button")}</button> : '';
        const diffTransactionPageLink = bankAccount.type === "bank_account" && bankAccount.has_financial_channel && authorizationService.can('bank_account_diff_transactions') ? <a className="btn btn-sm btn-light ms-1" href={`/bank-accounts${bankAccount.type === "bon_card" ? "/bon-cards" : ""}/${bankAccount.id}/diff-transactions`}>{i18n.t("bank-account-company-section.diff_transaction_page_link")}</a> : '';
        const editButton = bankAccount.deleted_at || authorizationService.cannot('bank_account_edit') ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenEditWindow(bankAccount.id) }}>{i18n.t("bank-account-company-section.edit_button")}</button>;
        const removeButton = bankAccount.deleted_at || authorizationService.cannot('bank_account_remove') ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleRemoveBankAccount(bankAccount.id) }}>{i18n.t("bank-account-company-section.remove_button")}</button>;
        const importBillButton = bankAccount.deleted_at || bankAccount.type !== "bank_account" || bankAccount.has_financial_channel ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenImportBillWindow(bankAccount.id) }}>{i18n.t("bank-account-company-section.import_bill_button")}</button>;
        //&& authorizationService.can('bank_account_import_bill')

        return (
          <>
          {transactionPageLink}
          {balanceButton}
          {diffTransactionPageLink}
          {importBillButton}
          {editButton}          
          {removeButton}
          </>
        );
      }
    }
  ];
  
  const callback = function (promis) {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };
  griew.options.add('table_class_name', 'table-hover'); 
  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
    function: (query) => bankAccountService.gridview(query),
    callback: callback
  };
}

export default CompanyBankAccountMainPage;